import script from "./TypesCongesView.vue?vue&type=script&setup=true&lang=js"
export * from "./TypesCongesView.vue?vue&type=script&setup=true&lang=js"

import "./TypesCongesView.vue?vue&type=style&index=0&id=0da38844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da38844"]])

export default __exports__